import { UnitOfMeasure, UnitOfMeasureEntity, UnitOfMeasureType } from "../../../model/unit-of-measure";
import { contains } from "../../../util/util";

export type UnitOfMeasureSelectorProps = {
  types?: UnitOfMeasureType[];
};

export const selectUoms = (values?: UnitOfMeasure[], selector?: UnitOfMeasureSelectorProps): UnitOfMeasure[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.types) {
      if (!contains(selector.types, t => t.code === v.type)) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const selectUomsAndTransform = (values?: UnitOfMeasure[], selector?: UnitOfMeasureSelectorProps): UnitOfMeasureEntity[] => {
  const selected = selectUoms(values, selector);
  return selected.map(m => UnitOfMeasureEntity.from(m));
};
